import React, { useMemo } from 'react';
import type { ShowText as ShowTextOp } from '~/app/_types/chat-script';
import { Paragraph, ParagraphProps } from '@styled-system/jsx';
import { token } from '@styled-system/tokens';

type Props = {
  op: ShowTextOp;
} & ParagraphProps;

export const ShowText = ({ op, ...pragraphProps }: Props) => {
  const text = useMemo(
    () => (/.*\n$/.test(op.text || '') ? `${op.text}\n` : op.text),
    [op.text]
  );

  return (
    <Paragraph
      textAlign={op.textAlign || 'center'}
      p="16px"
      lineHeight={1.5}
      whiteSpace="pre-wrap"
      borderRadius="8px"
      style={{
        fontSize: token(`fontSizes.${op.fontSize}`),
        fontWeight: op.fontWeight || 'normal',
        backgroundColor: op.backgroundColor || 'rgba(0, 0, 0, 0.78)',
        color: op.fontColor || token('colors.primary'),
      }}
      {...pragraphProps}
    >
      {text}
    </Paragraph>
  );
};
